// extracted by mini-css-extract-plugin
module.exports = {"container":"Slick__container___3Ylm4"};